export const FETCH_COMPOUND_SETTINGS_REQUEST =
  'compoundSettings/FETCH_COMPOUND_SETTINGS_REQUEST'
export const FETCH_COMPOUND_SETTINGS_SUCCESS =
  'compoundSettings/FETCH_COMPOUND_SETTINGS_SUCCESS'
export const FETCH_COMPOUND_SETTINGS_FAILURE =
  'compoundSettings/FETCH_COMPOUND_SETTINGS_FAILURE'

export const UPDATE_COMPOUND_SETTINGS_REQUEST =
  'compoundSettings/UPDATE_COMPOUND_SETTINGS_REQUEST'
export const UPDATE_COMPOUND_SETTINGS_SUCCESS =
  'compoundSettings/UPDATE_COMPOUND_SETTINGS_SUCCESS'
export const UPDATE_COMPOUND_SETTINGS_FAILURE =
  'compoundSettings/UPDATE_COMPOUND_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'compoundSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'compoundSettings/SET_DEFAULT_DATA'
